import { createReducer, on } from '@ngrx/store';
import { ProjectsState } from '../../models/organizations/projects.model';
import * as ProjectsActions from '../../actions/organizations/projects.actions';
import * as SpecActions from '../../actions/organizations/specs.actions';
import * as MarkdownsActions from '../../actions/organizations/markdowns.actions';
import * as AuthActions from '../../actions/auth.actions';
import { createOrganizationSuccess } from '../../actions/organizations/core.actions';

export const initialProjectsState: ProjectsState = {
  projects: [],
};

export const projectsReducer = createReducer(
  initialProjectsState,

  on(ProjectsActions.loadProjectsSuccess, (state, { projects }) => ({
    ...state,
    projects
  })),

  on(ProjectsActions.loadProjectByIdSuccess, (state, { project }) => {
    const exists = state.projects.some(p => p.data.id === project.data.id);
    return {
      ...state,
      projects: exists
        ? state.projects.map(p => p.data.id === project.data.id ? project : p)
        : [...state.projects, project]
    };
  }),

  on(ProjectsActions.createProjectSuccess, (state, { project }) => ({
    ...state,
    projects: [...state.projects, project]
  })),

  // Add handler for createOrganizationSuccess
  on(createOrganizationSuccess, (state, { project }) => ({
    ...state,
    projects: [...state.projects, project]
  })),

  on(ProjectsActions.updateProjectSuccess, (state, { project }) => ({
    ...state,
    projects: state.projects.map(p => p.data.id === project.data.id ? project : p)
  })),

  on(ProjectsActions.deleteProjectSuccess, (state, { projectId }) => ({
    ...state,
    projects: state.projects.filter(p => p.data.id !== projectId)
  })),

  // Add handlers for spec-related actions that update projects
  on(SpecActions.checkSpecAndCreateVersionSuccess, (state, { project }) => ({
    ...state,
    projects: state.projects.map(p => p.data.id === project.data.id ? project : p)
  })),
  on(SpecActions.updateSpecVersionSuccess, (state, { project }) => ({
    ...state,
    projects: state.projects.map(p => p.data.id === project.data.id ? project : p)
  })),
  on(SpecActions.deleteSpecVersionSuccess, (state, { project }) => ({
    ...state,
    projects: state.projects.map(p => p.data.id === project.data.id ? project : p)
  })),
  on(SpecActions.getSpecValidationResultsSuccess, (state, { project }) => ({
    ...state,
    projects: state.projects.map(p => p.data.id === project.data.id ? project : p)
  })),
  // Handle reorderSpecsSuccess to update project with new spec order
  on(SpecActions.reorderSpecsSuccess, (state, { project }) => ({
    ...state,
    projects: state.projects.map(p => p.data.id === project.data.id ? project : p)
  })),
  // Add handlers for markdown-related actions that update projects
  on(MarkdownsActions.checkMarkdownAndCreateVersionSuccess, (state, { project }) => ({
    ...state,
    projects: state.projects.map(p => p.data.id === project.data.id ? project : p)
  })),
  on(MarkdownsActions.updateMarkdownVersionSuccess, (state, { project }) => ({
    ...state,
    projects: state.projects.map(p => p.data.id === project.data.id ? project : p)
  })),
  on(MarkdownsActions.deleteMarkdownVersionSuccess, (state, { project }) => ({
    ...state,
    projects: state.projects.map(p => p.data.id === project.data.id ? project : p)
  })),
  on(MarkdownsActions.getMarkdownValidationResultsSuccess, (state, { project }) => ({
    ...state,
    projects: state.projects.map(p => p.data.id === project.data.id ? project : p)
  })),
  // Handle reorderMarkdownsSuccess to update project with new markdown order
  on(MarkdownsActions.reorderMarkdownsSuccess, (state, { project }) => ({
    ...state,
    projects: state.projects.map(p => p.data.id === project.data.id ? project : p)
  })),

  // Reset projects state on logout or clearUserData
  on(AuthActions.logout, AuthActions.clearUserData, () => initialProjectsState)
);